import { render, staticRenderFns } from "./EventCoordinators.vue?vue&type=template&id=6c985a64"
import script from "./EventCoordinators.vue?vue&type=script&lang=js"
export * from "./EventCoordinators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports